import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Skeleton from '@pedidosya/web-fenix/system/Skeleton';
import CardContainer from '@components/CardContainer';

const Container = styled(CardContainer)`
  height: ${({ height }) => height}px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: ${({ theme }) => theme.spacing(8)};
  padding: ${({ theme }) => theme.spacing(8)};
  max-width: 200px;
`;

const Name = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  div {
    border-radius: 12px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  div {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
    border-radius: 12px;
  }
`;

const ContainerShimmer = ({ height }) => (
  <Container height={height} id="desktop-shimmer-container">
    <Name>
      <Skeleton height="8" width="26" />
    </Name>
    <Content>
      <Skeleton height="12" width="18" />
      <Skeleton height="12" width="22" />
      <Skeleton height="12" width="24" />
    </Content>
  </Container>
);

ContainerShimmer.propTypes = {
  height: PropTypes.number,
};

ContainerShimmer.defaultProps = {
  height: 149,
};

export default memo(ContainerShimmer);
